import React from "react"
import {
  styled,
  IconButton,
  Menu as MUIMenu,
  MenuItem as BaseMenuItem,
  SxProps,
  Theme,
} from "@mui/material"
import { MoreHorizRounded } from "@mui/icons-material"

interface DropdownProps {
  items: {
    label: string
    disabled?: boolean
    onClick: () => void
  }[]
  menuItemStyles?: SxProps<Theme>
}

const Menu = styled(MUIMenu)(
  ({ theme }) => `
  z-index: 1;
  margin: 0px 0px 0px -18px;

  ${theme.breakpoints.up("sm")}{
    margin: 0px 0px 0px -36px;
  }
  `
)

const MenuItem = styled(BaseMenuItem)(
  ({ theme }) => `
  list-style: none;
  padding: 8px 24px;
  user-select: none;

  &:last-of-type {
    border-bottom: none;
  }

  &:hover:not(.disabled) {
    background-color: ${theme.palette.background.default};
    // outline: 1px solid ${theme.palette.divider};
  }
  `
)

export function Dropdown({ items, menuItemStyles }: DropdownProps) {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOnClick = (onClick: any) => {
    return () => {
      setAnchorEl(null)
      onClick()
    }
  }

  return (
    <div>
      <IconButton
        aria-controls="dropdown-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreHorizRounded fontSize="large" />
      </IconButton>
      <Menu
        id="dropdown-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{ paper: { sx: { borderRadius: 1.5 } } }}
      >
        {items.map(
          (item, i) =>
            item?.label && (
              <MenuItem
                key={i}
                divider={false}
                onClick={handleOnClick(item.onClick)}
                disabled={item.disabled || false}
                sx={menuItemStyles}
              >
                {item.label}
              </MenuItem>
            )
        )}
      </Menu>
    </div>
  )
}
